export class Aplicativo {
    
    idAplicativo: string;

    nombre: string;
    
    descripcion: string;

}
